import { CssBaseline } from '@mui/material';
import {
  createTheme,
  ThemeOptions,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';

import { createCommon, palette, scrollbar, sidebar } from './palette/palette';
import typography from './typography';
import shadows from './shadows';
import customShadows from './customShadows';
import componentsOverride from './overrides';
import GlobalStyles from './globalStyles';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { COMMON } from './palette/streammetric-palette';
import { Palette } from './palette/types';
import { useThemeType } from 'src/contexts/themeTypeContext/theme-type-context';

declare module '@mui/material/styles' {
  interface Theme {
    scrollbar: {
      thumb: string;
      thumbHover: string;
      background: string;
    };
    sidebar: {
      background: string;
      unselectedText: string;
      selectedSiteBackground: string;
      selectedNavItemBackground: string;
      alarmNotificationColor: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    scrollbar?: {
      thumb?: string;
      thumbHover?: string;
      background?: string;
    };
    sidebar?: {
      background: string;
      unselectedText: string;
      selectedSiteBackground: string;
      selectedNavItemBackground: string;
      alarmNotificationColor: string;
    };
  }
}

type Props = {
  children: React.ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  useEffect(() => {
    // get PRIMARY color data from the backend for a specific customer account by customerId
  }, []);
  const { themeType } = useThemeType();
  const location = useLocation();
  const dukesCustomerId = '01H0QF3X9D0ER9MW94AQ58DHBT';
  const DUKES_PRIMARY: Palette = {
    lighter: '#EFCFD5',
    light: '#DD7183',
    main: '#C51230',
    dark: '#B33449',
    darker: '#750A1C',
    contrastText: '#fff',
  };
  const CURRENT_COMMON = location.search.includes(dukesCustomerId)
    ? createCommon(DUKES_PRIMARY)
    : COMMON;

  const themeColors = palette(themeType, CURRENT_COMMON);

  const themeOptions: ThemeOptions = {
    palette: themeColors,
    typography,
    shape: { borderRadius: 8 },
    direction: 'ltr',
    shadows: shadows(themeType),
    customShadows: customShadows(themeType, themeColors),
    scrollbar: scrollbar(themeType),
    sidebar: sidebar(themeType),
  };

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
